import styled from 'styled-components';
import { color } from 'styles/settings';
import { withModifiers } from 'utils';
import { font, size } from 'styles/settings/typography';

export const Label = styled.label`
  line-height: 30px;
  cursor: pointer;
  font-size: ${size.sm};
  ${font.content.semiBold};
  user-select: none;
  margin-right: 16px;
`;

export const Track = styled.div`
  width: 56px;
  height: 30px;
  background-color: ${color.brand.greenDarkWithOpacity(0.35)};
  border-radius: 100px;
  padding: 3px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const Radio = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  transition: background-color 0.5s, left 0.5s;
  background-color: ${color.neutral.grayLighter};
  position: relative;
  left: 0;
`;

export const Container = styled.div`
  height: 38px;
  background-color: ${color.neutral.white};
  border-radius: 100px;
  box-shadow: 0px 5px 10px rgba(229, 229, 229, 0.8);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 4px 4px 20px;
  box-sizing: border-box;

  ${withModifiers('checked')`
        ${Radio} {
            background-color: ${color.brand.greenDark};
            left: calc(100% - 24px);
        } 
    `};
`;
